import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { RequistionCartState } from "@tKgpco/Handlers/RequistionCart/RequistionCartState";
import { Draft } from "immer";

const requistionCartInitialState: RequistionCartState = {
    isRequistionCartPresent: false,
    showDisclaimerForRequistionCart: false,
};

const reducer = {
    "Custom/RequistionCart/SetRequistionCartPresent": (
        draft: Draft<RequistionCartState>,
        action: { param: boolean },
    ) => {
        draft.isRequistionCartPresent = action.param;
    },
    "Custom/RequistionCart/SetShowDisclaimerForRequistionCart": (
        draft: Draft<RequistionCartState>,
        action: { param: boolean },
    ) => {
        draft.showDisclaimerForRequistionCart = action.param;
    },
};

export default createTypedReducerWithImmer(requistionCartInitialState, reducer);
